<template>
  <div class="add-basic-campaign">
    <ChooseCampaignOption
      v-loading="isLoading"
      class="add-basic-campaign__box"
      :title="$t('ADVERTISEMENT.CHOOSE_CAMPAIGN.BASIC')"
      :description="$t('ADVERTISEMENT.CHOOSE_CAMPAIGN.BASIC_DESCRIPTION')"
      :button-text="$t('ADVERTISEMENT.NEW_CAMPAIGN_BASIC')"
      :image="require('@/assets/images/campaigns/smart-campaign.svg')"
      @select="fetchRequirementsAndOpenModal"
    />
    <AddBasicCampaignModal
      v-model="showModal"
      :credit="credit"
      :apps="apps"
      @add="emitAdd"
    />
  </div>
</template>

<script>
import { Apps, Advertisement } from '@/api/api';
import ChooseCampaignOption from '../common/ChooseCampaignOption';
import permissions from '@/mixins/permissions';
import { AD_NEW_CAMPAIGN_BUTTON_CLICK } from '@/constants/gtm-events';
import AddBasicCampaignModal from './AddBasicCampaignModal';

export default {
  name: 'AddBasicCampaign',

  components: {
    ChooseCampaignOption,
    AddBasicCampaignModal,
  },

  mixins: [permissions],

  data() {
    return {
      isLoading: false,
      showModal: false,
      credit: 0,
      apps: [],
    };
  },

  methods: {
    emitAdd() {
      this.$emit('add');
    },
    fetchRequirementsAndOpenModal() {
      this.$gtm.trackEvent(AD_NEW_CAMPAIGN_BUTTON_CLICK);

      this.isLoading = true;

      return Promise.all([this.getCredit(), this.getApps()])
        .then(() => {
          this.showModal = true;
        })
        .catch(() => {})
        .finally(() => {
          this.isLoading = false;
        });
    },
    getCredit() {
      return Advertisement.getDeveloperCredit()
        .then(({ body: { credit = 0 } }) => {
          this.credit = credit;
        })
        .catch(({ body: { message } = {} }) => {
          if (message) {
            this.$message.error(message);
          }

          throw new Error(message);
        });
    },
    getApps() {
      if (this.apps.length) return Promise.resolve();

      return Apps.getList()
        .then(apps =>
          apps.filter(
            app =>
              this.hasAdvertisement(app.packageName) && app.published === 'P',
          ),
        )
        .then(apps => {
          this.apps = apps;
        })
        .catch(err => {
          this.$message.error(err.message);

          throw err;
        });
    },
  },
};
</script>

<style lang="scss">
.add-basic-campaign {
  &__box {
    height: 100%;
  }
}
</style>
